import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div.withConfig({displayName:'-Wrapper'})`
	position: relative;
	width: 100%;
	height: 600px;
	overflow: hidden;
`;
const Image = styled.img`
	width: 100%;
	height: 100%;
	object-fit: cover;
	object-position: center;
`;
const Panel = styled.div.withConfig({displayName:'-Panel'})`
	position: absolute;
	top: 0px;
	left: 0px;
	width: 100%;
	height: 100%;
	z-index: 2;
	color: #ffffff;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	text-shadow: 0px 3px 16px #0000004D;
`;
const Upper = styled.div.withConfig({displayName:'-Upper'})`
	font-size: 16px;
	line-height: 52px;
	font-weight: 500;
`;
const Title = styled.div.withConfig({displayName:'-Title'})`
	font-size: 55px;
	line-height: 52px;
	font-weight: 500;
`;
const Lower = styled.div.withConfig({displayName:'-Lower'})`
	font-size: 19px;
	line-height: 52px;
	font-weight: 300;
`;
const Cta = styled.div.withConfig({displayName:'-Cta'})`
	display: block;
	content: "";
	position: absolute;
	bottom: 0px;
	left: 0px;
	width: 100%;
	height: 200px;
	background: rgb(0,0,0);
	background: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.9) 100%);
	z-index: 2;
	display: flex;
	justify-content: center;
	align-items: flex-end;
	padding-bottom: 35px;
`;


const Header = ({src, upperText, title, lowerText, cta}) => {
  return (
    <Wrapper>
		<Image src={src} />
		<Panel>
			<Upper>{upperText}</Upper>
			<Title>{title}</Title>
			<Lower>{lowerText}</Lower>
		</Panel>
		{cta ? <Cta>{cta}</Cta> : null}
    </Wrapper>
  )
}

export default Header;
